import { useState } from 'react'

import { Button, Tooltip } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

const CopyButton = ({ target }: { target: string }) => {
  const [copied, setCopy] = useState<string>('')
  useEffect(() => {
    if (copied) {
      navigator.clipboard.writeText(copied)
      const timeout = setTimeout(() => {
        setCopy('')
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [copied])

  return (
    <Tooltip.Alt
      open={!!copied}
      attachment="bottom center"
      label={i18n.t('banking.accounts.side_panel.copied')}
      size="small"
      textSize="100"
    >
      <Button
        type={copied ? 'positive' : 'secondary'}
        onClick={copied ? () => null : () => setCopy(target)}
        iconName={copied ? 'check' : 'layers-front'}
      />
    </Tooltip.Alt>
  )
}
export default CopyButton
